import { CSRF_TOKEN } from "../constants";
import { upload } from "../api/cloudinary";

export default ({ path, redirect }) => ({
  loading: false,

  get label() {
    return this.loading ? "Uploading..." : "Select photo";
  },

  onClick() {
    this.$refs.input.click();
  },

  onChange(event) {
    this.handleFiles(event.target.files);
  },

  onBeforeUnload(event) {
    if (!this.loading) {
      return;
    }

    event.preventDefault();
    event.returnValue = "";
  },

  async handleFiles(files) {
    this.loading = true;

    const uploads = Array.from(files).map((file) => this.uploadFile(file));

    try {
      await Promise.all(uploads);

      this.loading = false;

      this.onSuccess();
    } catch (error) {
      console.error(error);

      this.loading = false;

      alert(`Something has gone wrong with the upload, please try again later or contact support.`);
    }
  },

  async uploadFile(file) {
    const photo = await upload(file);

    if (photo === null) {
      throw new Error("The photo could not be uploaded to Cloudinary.");
    }

    const response = await fetch(path, {
      headers: {
        Accept: "application/json",
        "X-CSRF-TOKEN": CSRF_TOKEN,
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify({
        public_id: photo.public_id,
      }),
    });

    if (!response.ok) {
      throw new Error("The photo could not be saved.");
    }
  },

  onSuccess() {
    window.location.href = redirect;
  },
});
